import type {leadNotesRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const leadNotesSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type LeadNotesSearch = z.output<typeof leadNotesSearchSchema>;
export type LeadNotesNavigateFn = ReturnType<typeof leadNotesRouteApi.useNavigate>;
